// extracted by mini-css-extract-plugin
module.exports = {"NoData":"Chart_NoData__1dBrd","LoadingText":"Chart_LoadingText__-xUy5"};